import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker, FlatButton } from 'material-ui';

const ProjectDateFilter = props => (
  <div>
    <h2>Filter period (optional)</h2>
    <DatePicker
      hintText="After"
      onChange={props.onAfterDateChange}
      value={props.updatedAtAfter}
    />
    <DatePicker
      hintText="Before"
      onChange={props.onBeforeDateChange}
      value={props.updatedAtBefore}
    />
    <FlatButton
      onClick={() => {
        props.onAfterDateChange(null, null);
        props.onBeforeDateChange(null, null);
      }}
      label="Reset"
    />
  </div>
);

ProjectDateFilter.propTypes = {
  onAfterDateChange: PropTypes.func,
  onBeforeDateChange: PropTypes.func,
  updatedAtAfter: PropTypes.object,
  updatedAtBefore: PropTypes.object
};

export default ProjectDateFilter;



// WEBPACK FOOTER //
// ./src/components/ProjectDateFilter.js